import { useQueryNotificationAlertCountUnread } from '@/api/queries/notification';
import Tabs from '@/components/ui/tabs';
import NotificationVoyager from '@/featured/apps/components/notification/NotificationVoyager';
import NotificationZone from '@/featured/apps/components/notification/NotificationZone';
import NotificationPort from '@/featured/apps/components/notification/NotificationPort';
import Link from 'next/link';

type Props = {};

export default function NotificationContent({}: Props) {
  const notificationAlertCountUnread = useQueryNotificationAlertCountUnread();

  return (
    <div className="h-full bg-white dark:bg-gray-900 flex flex-col items-center">
      <div
        className="w-full h-[calc(100%-50px)] overflow-x-hidden transform translate-x-0 transition ease-in-out duration-700 dark:bg-gray-900"
        id="notification"
      >
        <Tabs>
          <Tabs.MenuGroup className="justify-start">
            <Tabs.Menu index={0} title="Zone">
              {(notificationAlertCountUnread?.data?.notification_zone ?? 0) > 0 && (
                <span className="absolute top-0 right-0 px-1 text-xs text-white bg-red-500 dark:bg-red-500 rounded-full">
                  {notificationAlertCountUnread.data?.notification_zone}
                </span>
              )}
            </Tabs.Menu>
            <Tabs.Menu index={1} title="Port">
              {(notificationAlertCountUnread?.data?.notification_port ?? 0) > 0 && (
                <span className="absolute top-0 right-0 px-1 text-xs text-white bg-red-500 dark:bg-red-500 rounded-full">
                  {notificationAlertCountUnread.data?.notification_port}
                </span>
              )}
            </Tabs.Menu>
            <Tabs.Menu index={2} title="Voyager">
              {(notificationAlertCountUnread?.data?.voyager_alarm ?? 0) > 0 && (
                <span className="absolute top-0 right-0 px-1 text-xs text-white bg-red-500 dark:bg-red-500 rounded-full">
                  {notificationAlertCountUnread.data?.voyager_alarm}
                </span>
              )}
            </Tabs.Menu>
          </Tabs.MenuGroup>

          <Tabs.PanelGroup>
            <Tabs.Panel index={0}>
              <NotificationZone />
            </Tabs.Panel>
            <Tabs.Panel index={1}>
              <NotificationPort />
            </Tabs.Panel>
            <Tabs.Panel index={2}>
              <NotificationVoyager />
            </Tabs.Panel>
          </Tabs.PanelGroup>
        </Tabs>
      </div>

      <Link
        href="/dashboard/notifications/history"
        className="block w-80 px-4 py-2 mt-3 text-sm font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
      >
        View All Notifications
      </Link>
    </div>
  );
}
